import { useEffect, useState } from "react";
import { Method } from "axios";
import { useAxios } from "./UseAxios/UseAxiosHook";

interface ApiOptions {
  method?: Method;
  payload?: any;
  autoCall?: boolean;
  dependencies?: any[];
}

interface UseApiResult<T> {
  data: T | null | any[];
  loading: boolean;
  error: any;
  callApi: (payload?: any, customEndpoint?: string) => Promise<T | undefined>;
}

const extractData = (res: any) => {
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res)) return res;
  if (res?.data && typeof res.data === "object") return res.data;
  return res;
};

export function useApi<T = any>(
  endpoint: string,
  {
    method = "GET",
    payload = null,
    autoCall = true,
    dependencies = [],
  }: ApiOptions = {},
): UseApiResult<T> {
  const { request, loading, data: responseData, errors } = useAxios();
  const [data, setData] = useState<T | any[] | null>(null);

  // callApi mimics old hook signature
  const callApi = async <T>(
    customPayload = payload,
    customEndpoint?: string,
  ): Promise<T | undefined> => {
    const url = customEndpoint || endpoint;
    const result = await request({
      url,
      method,
      data: customPayload,
    });
    // console.log(result);
    const final = await extractData(result);
    setData(final);
    return result;
  };

  // autoCall behavior like old hook
  useEffect(() => {
    if (autoCall) {
      callApi();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return {
    data,
    loading,
    error: errors,
    callApi,
  };
}
